module.exports = __webpack_public_path__ + "static/img/tomcat.5870097c.png";